import React from "react";
import avsync from "../imgs/avsync.jpg";
// import BetaTesterInvite from "../components/BetaTesterInvite";

const Portfolio = () => {
  return (
    <div className="portfolio">
      <h1>Portfolio</h1>
      <p className="intro-text">
        A showcase of my featured project — blending creativity, technology, and
        problem-solving to bring real-world solutions to life.
      </p>

      {/* === Project | AV Sync App === */}
      <div className="project-item">
        <img
          src={avsync}
          alt="AV Sync App screenshot"
          className="project-img"
        />
        <div className="project-content">
          <h2 className="project-title">AV Sync</h2>
          <p className="project-desc">
            AV Sync is a cross-platform app designed for production and
            technical teams to scan, track, and manage AV equipment across
            networks. It features real-time device scanning, MongoDB storage,
            Firebase Auth integration, and a responsive React front end. Built
            to simplify complex workflows while keeping everything organized and
            accessible.
          </p>

          <div className="project-tags">
            <span>React</span>
            <span>Node</span>
            <span>Express</span>
            <span>MongoDB</span>
            <span>Firebase</span>
          </div>

          <div className="project-links">
            {/* <a
              className="post-links"
              href="https://2506-wdv-349-victoria-savannah.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              Live Site
            </a> */}
            <a
              className="post-links"
              href="/avsync"
              // target="_blank"
              // rel="noopener noreferrer"
            >
              Beta Release Notes
            </a>
            {/* <a
              className="post-links"
              href="https://github.com/VictoriaSavannah-FS/avsync-app"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Code
            </a> */}
          </div>
        </div>
        {/* <BetaTesterInvite /> */}
      </div>
      {/* === Project | SVX Blog === */}
      <div className="project-item">
        <img
          src={require("../imgs/svxBlog.jpg")}
          alt="SVX Blog Screenshot"
          className="project-img"
        />
        <div className="project-content">
          <h2 className="project-title">SVX Blog</h2>
          <p className="project-desc">
            Before creating this portfolio, I built an earlier project called
            SVX Blog — my first step into React layouts, dark mode design, and
            structured blog components. It served as the foundation for the
            overall theme and layout of this site. I kept all of my original
            blog posts and brought them here, expanding the design and refining
            the experience to reflect how my skills, creativity, and process
            have evolved over time.
          </p>
          <div className="project-tags">
            <span>React</span>
            <span>Vite</span>
            <span>CSS</span>
            <span>Vercel</span>
          </div>
          <div className="project-links">
            <a
              className="post-links"
              href="https://1-9-svx-blog.vercel.app/posts"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Live Site
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
